import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Button, Drawer, Descriptions } from 'antd'
import { useHistory } from 'react-router-dom'
import { PageHeader } from '../Common'
import { useCurrentUserRole } from '../../redux/slices/session'
import TransmissionSidebar from '../Common/TransmissionSidebar'

export default function ReportPatientHeader({
  report,
  backPath,
  onShowIssuesForm,
  showIssuesForm,
}) {
  const [visiblePatient, setVisiblePatient] = useState(false)
  const history = useHistory()
  // eslint-disable-next-line no-unused-vars
  const goToReport = useCallback(() => history.push(backPath), [
    backPath,
    history,
  ])

  const userRole = useCurrentUserRole()
  const isClinician = userRole === 'clinician'

  const title = `${isClinician ? 'Generate' : 'Update'} BioBridge Report`

  return (
    <>
      <PageHeader
        title={title}
        onBack={!isClinician && backPath && (() => history.goBack())}
        extra={
          <>
            <Button onClick={() => setVisiblePatient(true)}>Patient</Button>
            {showIssuesForm && (
              <Button onClick={onShowIssuesForm} icon="warning" shape="round">
                Report parsing issues
              </Button>
            )}
          </>
        }
      />
      <Drawer
        title="Patient Information"
        width={360}
        placement="right"
        onClose={() => setVisiblePatient(false)}
        visible={visiblePatient}
      >
        <Descriptions column={1} size="small" layout="vertical">
          <Descriptions.Item label="Device Type">
            {report.device.deviceModel.deviceType.name}
          </Descriptions.Item>
          <Descriptions.Item label="Device Serial Number">
            {report.device.serialNumber}
          </Descriptions.Item>
        </Descriptions>
        <TransmissionSidebar
          patient={report.patient}
          practiceId={report.patient.practiceId}
        />
      </Drawer>
    </>
  )
}

ReportPatientHeader.propTypes = {
  report: PropTypes.shape().isRequired,
  backPath: PropTypes.string,
  onShowIssuesForm: PropTypes.func,
  showIssuesForm: PropTypes.bool,
}

ReportPatientHeader.defaultProps = {
  backPath: '',
  onShowIssuesForm: () => {},
  showIssuesForm: false,
}
